import { withInstall } from '@zoryn/utils'
import Popconfirm from './src/popconfirm.vue'

import type { SFCWithInstall } from '@zoryn/utils'

export const ZPopconfirm: SFCWithInstall<typeof Popconfirm> =
  withInstall(Popconfirm)
export default ZPopconfirm

export * from './src/popconfirm'
